import { render, staticRenderFns } from "./game-detail.vue?vue&type=template&id=6217eee6&"
import script from "./game-detail.vue?vue&type=script&lang=js&"
export * from "./game-detail.vue?vue&type=script&lang=js&"
import style0 from "./game-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports